import type { ApolloError } from '@apollo/client';
import { useTypedQuery } from '../lib/generated/zeus/apollo';
import { objValueNullToUndefined } from '../lib/utils';
import { teamSelector } from './selectors/team';
import type { StoredTeam } from './types';

export const teamByIdQueryName = 'queryTeamById';

/**
 * Provides GraphQL query to fetch a Team.
 * Using query instead of team_by_pk as query by primary key does not filter out Deleted record.
 * @param onCompleted callback for handling result.
 * @param onError callback for handling error.
 * @param id of the Team to fetch.
 * @param skip determines if the query should be skipped.
 * @returns custom hook that provides GraphQL query to fetch Team by ID.
 */
const useQueryTeamById = (
  onCompleted?: (d?: StoredTeam) => void,
  onError?: (e: ApolloError) => void,
  id?: string,
  skip?: boolean
) => {
  const result = useTypedQuery(
    {
      team: [{ where: { id: { _eq: id } } }, teamSelector],
    },
    {
      apolloOptions: {
        onCompleted: (data) => {
          if (onCompleted !== undefined) {
            const queriedTeam = objValueNullToUndefined<StoredTeam>(
              data.team[0]
            );

            onCompleted(queriedTeam);
          }
        },
        onError,
        skip,
      },
      operationOptions: {
        operationName: teamByIdQueryName,
      },
    }
  );

  return result;
};

export default useQueryTeamById;
